import { MakeLogicType, actions, kea, path, reducers } from 'kea'
import { loaders } from 'kea-loaders'

import api from 'lib/api'
import { ErrorTrackingSpikeEvent } from 'lib/components/Errors/types'

import { DateRange } from '~/queries/schema/schema-general'

import { dateRangeToIsoBounds } from '../utils'

// Generated by kea-typegen. Update if you're an agent, ignore if you're human.
export interface batchSpikeEventsLogicValues {
    rawSpikeEvents: ErrorTrackingSpikeEvent[]
    rawSpikeEventsLoading: boolean
    spikeEventsByIssueId: Record<string, ErrorTrackingSpikeEvent[]>
}

// Generated by kea-typegen. Update if you're an agent, ignore if you're human.
export interface batchSpikeEventsLogicActions {
    loadSpikeEventsForIssues: (
        issueIds: string[],
        dateRange?: DateRange
    ) => {
        dateRange: DateRange | undefined
        issueIds: string[]
    }
    loadSpikeEventsForIssuesFailure: (
        error: string,
        errorObject?: any
    ) => {
        error: string
        errorObject?: any
    }
    loadSpikeEventsForIssuesSuccess: (
        rawSpikeEvents: ErrorTrackingSpikeEvent[],
        payload?: {
            dateRange: DateRange | undefined
            issueIds: string[]
        }
    ) => {
        rawSpikeEvents: ErrorTrackingSpikeEvent[]
        payload?: {
            dateRange: DateRange | undefined
            issueIds: string[]
        }
    }
}

export type batchSpikeEventsLogicType = MakeLogicType<batchSpikeEventsLogicValues, batchSpikeEventsLogicActions>

export const batchSpikeEventsLogic = kea<batchSpikeEventsLogicType>([
    path(['products', 'error_tracking', 'logics', 'batchSpikeEventsLogic']),

    actions({
        loadSpikeEventsForIssues: (issueIds: string[], dateRange?: DateRange) => ({ issueIds, dateRange }),
    }),

    loaders({
        rawSpikeEvents: [
            [] as ErrorTrackingSpikeEvent[],
            {
                loadSpikeEventsForIssues: async ({ issueIds, dateRange }, breakpoint) => {
                    if (issueIds.length === 0) {
                        return []
                    }
                    await breakpoint(100)
                    const { dateFrom, dateTo } = dateRangeToIsoBounds(dateRange)
                    const response = await api.errorTracking.getSpikeEvents({ issueIds, dateFrom, dateTo })
                    return response.results
                },
            },
        ],
    }),

    reducers({
        spikeEventsByIssueId: [
            {} as Record<string, ErrorTrackingSpikeEvent[]>,
            {
                loadSpikeEventsForIssues: () => ({}),
                loadSpikeEventsForIssuesSuccess: (_, { rawSpikeEvents }) => {
                    const grouped: Record<string, ErrorTrackingSpikeEvent[]> = {}
                    for (const event of rawSpikeEvents) {
                        const id = event.issue.id
                        if (!grouped[id]) {
                            grouped[id] = []
                        }
                        grouped[id].push(event)
                    }
                    return grouped
                },
            },
        ],
    }),
])
